import React, { PureComponent } from 'react'
import serviceBuilder from './serviceBuilder'
import { interpolate } from '../utils/commonUtils'

export const generateServices = (serviceConfig, { show, hide, ...propRest }) => serviceConfig
  .map(({ service, url, ...configrest }) => ({
    [service]: serviceBuilder({
      url: interpolate(url, propRest),
      ...configrest,
      show,
      hide,
    }),
  })).reduce((acc, fn) => Object.assign(acc, fn), {})

export default function injectServices(serviceConfig = []) {
  return function wrapWithInjectedServices(WrappedComponent) {
    class WrapperComponent extends PureComponent {
      render() {
        const services = generateServices(serviceConfig, this.props)
        return <WrappedComponent services={services} {...this.props} />
      }
    }
    return WrapperComponent
  }
}
